import React, { memo } from 'react'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'

import * as yup from 'yup'

import { useShallowEqualSelector } from 'custom-hooks'

import TextInput from 'components/CommonUI/TextInput/TextInput'
import Button from 'components/CommonUI/Button/Button'
import TitleSection from './TitleSection'

import {
  getProfileDataSelector,
  editProfile,
  getErrorMessageSelector,
} from 'redux/reducers/profile'
import PhoneInputStyled from 'components/CommonUI/PhoneInput/PhoneInput'

let profileSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim("First name can't start or end the space character")
    .strict()
    .matches(/^[a-zA-Z\s-']+$/, 'First name can only contain letters')
    .min(2, 'First name must be at least 2 characters')
    .max(256, 'First name must be at most 256 characters')
    .required('First name is a required'),
  last_name: yup
    .string()
    .trim("Last name can't start or end the space character")
    .strict()
    .matches(/^[a-zA-Z\s-']+$/, 'Last name can only contain letters')
    .min(2, 'Last name must be at least 2 characters')
    .max(256, 'Last name must be at most 256 characters')
    .required('Last name is a required'),
  phone_number: yup.number(),
})

const ProfilePersonalInfoForm = () => {
  const dispatch = useDispatch()
  const profile = useShallowEqualSelector(getProfileDataSelector)
  const errorMessage = useShallowEqualSelector(getErrorMessageSelector)

  const formik = useFormik({
    initialValues: {
      first_name: profile.first_name || '',
      last_name: profile.last_name || '',
      phone_number: profile.phone_number || '',
    },
    onSubmit: (values) => {
      const _data = {}

      for (const [key, value] of Object.entries(values)) {
        if (profile[key]?.trim() !== values[key]?.trim()) {
          _data[key] = value?.trim()
        }
      }

      dispatch(editProfile(_data))
    },
    validationSchema: profileSchema,
  })

  return (
    <form
      className="personal_information_section form_section"
      onSubmit={formik.handleSubmit}
    >
      <TitleSection title="Personal information" errorMessage={errorMessage} />
      <div className="form_row">
        <TextInput
          label="First name"
          classNameContainer="profile_form_input name_input"
          placeholder="James"
          name="first_name"
          onChange={formik.handleChange}
          value={formik.values.first_name}
          errorMessage={formik.errors.first_name}
        />
        <TextInput
          label="Last name"
          classNameContainer="profile_form_input name_input"
          placeholder="Ratcliff"
          name="last_name"
          onChange={formik.handleChange}
          value={formik.values.last_name}
          errorMessage={formik.errors.last_name}
        />
      </div>
      <div className="form_row">
        <TextInput
          label="Email"
          classNameContainer="profile_form_input"
          placeholder="myemail@mail.com"
          type="email"
          defaultValue={profile.email}
          name="email"
          disabled
        />
      </div>
      <div className="form_row">
        <TextInput
          label="Works in"
          classNameContainer="profile_form_input name_input"
          defaultValue="Papa Johns Inc."
          disabled={true}
        />
        <PhoneInputStyled
          label="Number"
          classNameContainer="profile_input_label profile_form_input name_input"
          name="phone_number"
          onChange={formik.handleChange}
          value={formik.values.phone_number}
        />
      </div>
      <div className="save_button_container form_row">
        <Button
          className="save_changed_button"
          type="submit"
          disabled={!(formik.isValid && formik.dirty)}
        >
          Save changes
        </Button>
      </div>
    </form>
  )
}

export default memo(ProfilePersonalInfoForm)
